// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { Locale } from "./i18n";

export default {
    display: "English",
    code: "en",
    translation: {
        "arc.angle": "Angle",
        "arc.start": "Start",
        "axis.x": "X Axis",
        "axis.y": "Y Axis",
        "axis.z": "Z Axis",
        "body.arc": "Arc",
        "body.bolean": "Boolean",
        "body.box": "Box",
        "body.pyramid": "Pyramid",
        "body.cylinder": "Cylinder",
        "body.cone": "Cone",
        "body.group": "Group",
        "body.sphere": "Sphere",
        "body.ellipse": "Ellipse",
        "body.circle": "Circle",
        "body.face": "Face",
        "body.fuse": "Fuse",
        "body.imported": "Imported",
        "body.line": "Line",
        "body.polygon": "Polygon",
        "body.prism": "Prism",
        "body.rect": "Rectangle",
        "body.revol": "Revolve",
        "body.sweep": "Sweep",
        "body.wire": "Wire",
        "box.dx": "Length",
        "box.dy": "Width",
        "box.dz": "Height",
        "body.editableShape": "Editable Shape",
        "body.meshNode": "Mesh Node",
        "body.multiShape": "Multi Shape",
        "circle.center": "Center",
        "circle.radius": "Radius",
        "ellipsoid.radiusX": "RadiusX",
        "ellipsoid.radiusY": "RadiusY",
        "ellipsoid.radiusZ": "RadiusZ",
        "ellipse.majorRadius": "majorRadius",
        "ellipse.minorRadius": "minorRadius",
        "command.act.alignCamera": "AlignCamera",
        "command.boolean.common": "Intersect",
        "command.boolean.cut": "Cut",
        "command.boolean.join": "Join",
        "command.convert.fuse": "Fuse",
        "command.convert.revol": "Revolve",
        "command.convert.sweep": "Sweep",
        "command.convert.toFace": "ToFace",
        "command.convert.toShell": "ToShell",
        "command.convert.toSolid": "ToSolid",
        "command.convert.toWire": "ToWire",
        "command.create.arc": "Arc",
        "command.create.bezier": "Bezier",
        "command.create.box": "Box",
        "command.create.circle": "Circle",
        "command.create.cone": "Cone",
        "command.create.copyShape": "CopyShape",
        "command.create.cylinder": "Cylinder",
        "command.create.ellipse": "Ellipse",
        "command.create.ellipsoid": "Ellipsoid",
        "command.create.extrude": "Extrude",
        "command.create.folder": "Folder",
        "command.create.group": "Create Group",
        "command.create.line": "Line",
        "command.create.offset": "Offset",
        "command.create.polygon": "Polygon",
        "command.create.pyramid": "Pyramid",
        "command.create.rect": "Rectangle",
        "command.create.section": "Section",
        "command.create.sphere": "Sphere",
        "command.create.thickSolid": "ThickSolid",
        "command.doc.new": "New Document",
        "command.doc.open": "Open Document",
        "command.doc.save": "Save Document",
        "command.doc.saveToFile": "SaveToFile",
        "command.edit.redo": "Redo",
        "command.edit.undo": "Undo",
        "command.file.export": "Export",
        "command.file.import": "Import",
        "command.measure.angle": "Angle",
        "command.measure.length": "Length",
        "command.measure.select": "Select",
        "command.modify.array": "Array",
        "command.modify.break": "Break",
        "command.modify.brushAdd": "BrushAdd",
        "command.modify.brushRemove": "BrushRemove",
        "command.modify.brushClear": "BrushClear",
        "command.modify.chamfer": "Chamfer",
        "command.modify.deleteNode": "DeleteNode",
        "command.modify.explode": "Explode",
        "command.modify.fillet": "Fillet",
        "command.modify.mirror": "Mirror",
        "command.modify.move": "Move",
        "command.modify.removeFeature": "RemoveFeature",
        "command.modify.removeShapes": "RemoveShapes",
        "command.modify.rotate": "Rotate",
        "command.modify.split": "Split",
        "command.modify.trim": "Trim",
        "command.special.last": "__Last_COMMAND__",
        "command.test.performace": "Performance Test",
        "command.wechat.group": "Wechat",
        "command.workingPlane.alignToPlane": "Align",
        "command.workingPlane.fromSection": "Section",
        "command.workingPlane.set": "Set",
        "command.workingPlane.toggleDynamic": "Toggle",
        "common.angle": "Angle",
        "common.area": "Area",
        "common.back": "Back",
        "common.cancel": "Cancel",
        "common.clone": "Clone",
        "common.color": "Color",
        "common.confirm": "Confirm",
        "common.general": "General",
        "common.length": "Length",
        "common.material": "Material",
        "common.matrix": "Matrix",
        "common.name": "Name",
        "common.normal": "Normal",
        "common.opacity": "Opacity",
        "common.thickness": "Thickness",
        "common.type": "Type",
        "common.volume": "Volume",
        "dialog.title.selectWorkingPlane": "Select Working Plane",
        "entity.editable": "Editable Entity",
        "entity.parameter": "Parameter Entity",
        "error.default:{0}": "error: {0}",
        "error.input.cannotInputANumber": "Overlap with reference point, 1 number cannot be entered",
        "error.input.invalidNumber": "Please enter a valid number, separated by ,",
        "error.input.threeNumberCanBeInput": "Reference point is empty, only 3 numbers can be entered",
        "error.input.unsupportedInputs": "Exceeds the maximum number of inputs",
        "error.import.unsupportedFileType:{0}": "Unsupported file type: {0}",
        "error.export.noNodeCanBeExported": "No node can be exported",
        "file.format": "Format",
        "home.recent": "Recent",
        "home.welcome": "Welcome to hnch CAD",
        "items.header": "Items",
        "items.tool.delete": "Delete",
        "items.tool.expandAll": "Expand All",
        "items.tool.newFolder": "New Folder",
        "items.tool.unexpandAll": "Unexpand all",
        "line.end": "End",
        "line.start": "Start",
        "line.type.line": "Line",
        "line.type.xline": "XLine",
        "material.texture.image": "Image",
        "material.texture.rotation": "Rotation",
        "material.texture.wrapS": "Wrap S",
        "material.texture.wrapT": "Wrap T",
        "material.texture.repeat": "Repeat",
        "material.texture.offset": "Offset",
        "material.map": "Map",
        "material.specular": "Specular",
        "material.shininess": "Shininess",
        "material.emissive": "Emissive",
        "material.specularMap": "Specular Map",
        "material.normalMap": "Normal Map",
        "material.bumpMap": "BumpMap",
        "material.roughnessMap": "Roughness Map",
        "material.emissiveMap": "Emissive Map",
        "material.metalness": "Metalness",
        "material.metalnessMap": "Metalness Map",
        "material.roughness": "Roughness",
        "model.visible": "Visible",
        "option.command.repeat": "Repeat",
        "option.command.isFace": "Face",
        "option.command.isRoundCorner": "Round Corner",
        "option.command.thickness": "Thickness",
        "option.command.isConnected": "Connected",
        "option.command.isConvertInstance": "Convert Instance",
        "option.command.insertPoint": "Insert Point",
        "polygon.points": "Points",
        "prompt.default":
            "Middle mouse button to pan the view, Shift + Middle button to rotate the view, Middle button to scroll the zoom view",
        "prompt.deleteDocument{0}": "Do you want to delete {0}?",
        "prompt.pickCircleCenter": "pick center, ESC key to cancel",
        "prompt.pickFistPoint": "Pick first point, ESC key to cancel",
        "prompt.pickNextPoint": "pick next point, ESC key to cancel",
        "prompt.pickRadius": "input radius, ESC key to cancel",
        "prompt.polygon.close": "Close",
        "prompt.saveDocument{0}": "Do you want to save the changes to {0}?",
        "prompt.select.edges": "Please select edges",
        "prompt.select.faces": "Please select faces",
        "prompt.select.models": "Please select models",
        "prompt.select.noModelSelected": "No model selected",
        "prompt.select.section": "Please select section",
        "prompt.select.shape": "Please select shape",
        "prompt.select.solids": "Please select solids",
        "prompt.select.path": "Please select path",
        "prompt.select.vertexes": "Please select vertexes",
        "prompt.select.wires": "Please select wires",
        "toast.snap.notFoundValidPoint": "No valid point",
        "properties.group.transform": "Transform",
        "properties.header": "Properties",
        "properties.multivalue": "Multi Value",
        "rect.dx": "Length",
        "rect.dy": "Width",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.act": "Act",
        "ribbon.group.boolean": "Boolean",
        "ribbon.group.converter": "Converter",
        "ribbon.group.draw": "Drawing",
        "ribbon.group.importExport": "Import/Export",
        "ribbon.group.measure": "Measure",
        "ribbon.group.modify": "Modify",
        "ribbon.group.other": "Other",
        "ribbon.group.selection": "Selection",
        "ribbon.group.tools": "Tools",
        "ribbon.group.workingPlane": "Working Plane",
        "ribbon.tab.draw": "Drawing",
        "ribbon.tab.file": "File",
        "ribbon.tab.tools": "Tools",
        "ribbon.tab.startup": "Startup",
        "snap.center": "Center",
        "snap.end": "End",
        "snap.intersection": "Intersection",
        "snap.mid": "Middle",
        "snap.perpendicular": "Perpendicular",
        "snap.nearest": "Nearest",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Tracking",
        "toast.command.{0}excuting": "Command {0} is runing",
        "toast.converter.error": "Converter error",
        "toast.converter.invalidColor": "The color is invalid",
        "toast.delete{0}Objects": "Deleted {0} objects",
        "toast.document.noActivated": "No document activated",
        "toast.document.saved": "Document saved",
        "toast.downloading": "Downloading",
        "toast.excuting{0}": "Excuting {0}",
        "toast.fail": "Fail",
        "toast.read.error": "Read error",
        "toast.select.noSelected": "No selected",
        "toast.success": "Success",
        "transform.rotation": "Rotation",
        "transform.scale": "Scale",
        "transform.translation": "Translation",
        "vertex.point": "Point",
    },
} satisfies Locale;
